import { z } from 'zod';

/** Valeurs du formulaire « Je modifie mes informations de contact ». */
export interface ChangeInformationsValues {
    tiers?: number | string;
    tel_mobile?: string;
    tel_fixe?: string;
    email?: string;
    email_confirmation?: string;
    password?: string;
}

const REQUIRED_FIELDS = ['tel_mobile', 'email', 'email_confirmation'] as const;

/**
 * Contrôle du formulaire de contact.
 *
 * Même ordre que l'ancien `validate.js` : la dernière règle qui touche un champ fixe son message.
 */
export const changeInformationsSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;
    const errors: Record<string, string> = {};

    for (const field of REQUIRED_FIELDS) {
        if (!v[field]) errors[field] = 'Le champ est obligatoire';
    }

    if (v['tel_mobile'] && !/^(?:(?:\+|00)33|0)\s*[6-7](?:[\s.-]*\d{2}){4}$/.test(String(v['tel_mobile']))) {
        errors['tel_mobile'] = 'Le numéro de téléphone mobile saisi est invalide';
    }

    if (v['tel_fixe'] && !/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/.test(String(v['tel_fixe']))) {
        errors['tel_fixe'] = 'Le numéro de téléphone fixe saisi est invalide';
    }

    if (v['email'] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(String(v['email']))) {
        errors['email'] = "l'adresse email saisi est invalide";
    }

    if (v['email'] !== v['email_confirmation']) {
        errors['email'] = "la confirmation d'email n'est pas valide";
        errors['email_confirmation'] = "la confirmation d'email n'est pas valide";
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
